import React from 'react'

import clsx from 'clsx'

import classes from './ControlLabel.module.scss'

/** @type {import("./types").default} */
const ControlLabel = ({
  disabled = false,
  labelComponent,
  control,
  type,
  fullWidth = false,
  color,
  labelClassName,
}) => {
  return (
    <label
      className={clsx('ControlLabel', classes.root, classes[`${type}Label`], {
        [classes.fullWidth]: fullWidth,
        [classes.disabled]: disabled,
        [classes.secondary]: color === 'secondary',
      })}
    >
      {control}
      <span className={labelClassName}>{labelComponent}</span>
    </label>
  )
}

export default ControlLabel
